var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
        _vm.configuratorStore.car && _vm.configuratorStore.priceRequest && _vm.configuratorStore.priceResult
    )?_c('div',{staticClass:"order"},[_c('div',{staticClass:"container main"},[_c('router-view',{attrs:{"name":"main"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }